import { NgClass } from "@angular/common";
import { ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Firestore } from "@angular/fire/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { ActivatedRoute, Data, Params, Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { LoadingService } from "@core/loading.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { VoucherClaimResult } from "@interfaces/vouchers.i";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, interval, of, Subject } from "rxjs";
import { catchError, switchMap, take } from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { PaymentService } from "src/app/services/payment.service";
import { RequestProfileService } from "src/app/services/RequestBodyService/RequestProfile/request-profile.service";
import { SafeLocalStorageService } from "src/app/services/safe-local-storage.service";
import { VoucherService } from "src/app/services/vouchers.service";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { StoreRepositoryService } from "../../store/store-repository.service";
@Component({
  selector: "app-free-reg-step4d",
  templateUrl: "./free-reg-step4d.component.html",
  styleUrls: ["./free-reg-step4d.component.scss", "../onesignal.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    NgClass,
    MatProgressSpinner,
    SafeHtmlPipe,
    TranslatePipe,
  ],
})
export class FreeRegStep4dComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  voucher$ = new BehaviorSubject("");
  voucherRedeemForm: FormGroup;
  spinnerAnimation: boolean;
  gc: string;
  progressBar: number;
  proceed: boolean = true;
  isButtonDisabled = true;
  timer$;
  sub: any;
  selectedLanguage: string;
  purchaseDetail: any;
  paymentPageData: any;
  claimFromList: boolean;
  jackpots;
  claimSuccess: boolean;
  translatedToastMsg: any;
  vc: string;
  isVoucherIsInvalid$ = new BehaviorSubject<any>("");
  // vc: string;
  qParams: any;
  userProduct$ = new BehaviorSubject<any>({});
  prosub_id: any;
  loaded: boolean;
  isOnline: boolean = true;
  versionPaymentPageData: Data;
  versionPaymentOptMsg: Data;
  callFromPromotion = "";
  reason = "";
  optMSgContent: string;
  additionalAwardId: number;
  public TP1: string;
  public Tp2: string;
  public TP3: string;
  public T_ID: string;
  public Prosub_id: any;
  private safeLocalStorage = inject(SafeLocalStorageService);
  private destroyRef = inject(DestroyRef);

  constructor(
    private firestore: Firestore,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private voucherService: VoucherService,
    private changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    public GTMservice: GTMSegmentService,
    private storeService: StoreRepositoryService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private paymentService: PaymentService,
    private snackService: MySnackBarService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private matDialog: MatDialog,
    private AuthPartialRegService: AuthPartialRegService,
    private RequestProfileService: RequestProfileService,
  ) {
    // Safely initialize tracking parameters
    this.TP1 = this.safeLocalStorage.getItem("TP1");
    this.Tp2 = this.safeLocalStorage.getItem("TP2");
    this.TP3 = this.safeLocalStorage.getItem("TP3");
    this.T_ID = this.safeLocalStorage.getItem("T_ID");
    this.Prosub_id = this.safeLocalStorage.getItem("prosub_id");
    
    this.loaded = false;
    this.qParams = this.GTMservice.userProduct$.value;
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.callSigUpForSalesResponse$.subscribe((d) => {
      try {
        if (d && location.href.search("free-reg-step4d") > -1) {
          if (d && d?.response?.status === "FAIL") {
            this.authService.callSigUpForSalesResponse$.next(null);
            const proSub = this.safeLocalStorage.getItem("prosub_id");
            this.authService.logout().then();
            if (proSub === null) return;
            this.router.navigateByUrl(`partial-registration?prosub_id=${proSub}`);
            if (d?.response?.message === "MSN_INVALID") {
              const message = "Registration failed, please enter a correct phone number.";
              this.authService.showAnonymousUserMessage(message);
              return;
            }
            this.authService.showAnonymousUserMessage();
          }
        }
      } catch (error) {
        return error;
      }
    });

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  ngOnInit() {
    Network.addListener("networkStatusChange", (e) => {
      try {
        if (e.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        return error;
      }
    });
    const navExtras = this.router.getCurrentNavigation()?.extras;
    let navState = navExtras?.state as Data;
    this.vc = navExtras?.queryParams?.vc;

    this.activatedRoute.queryParams.subscribe(
      (params: Data) => {
        this.callFromPromotion = params?.call_from;
        this.gc = params?.gc;
        this.AuthPartialRegService.giftCard = this.gc;
        // this.loadingService.present();
        // this.matDialog.closeAll();
        if (params?.vc) {
          this.vc = params?.vc;
          this.voucherRedeemFormValidate();
        }
        this.prosub_id = params?.Prosub_ID ? params?.Prosub_ID : params?.prosub_id;
        if (this.prosub_id) {
          this.safeLocalStorage.setItem("prosub_id", this.prosub_id);
        }
        [this.TP1, this.Tp2, this.TP3, this.T_ID] = this.getCaseInsensitiveParamsValue(params);
        if (navState && !this.gc) {
          const didBindFromNavState = this.applyPartialRegResponse(navState);
          navState = null;
          if (didBindFromNavState) {
            return;
          }
        }
        if (this.prosub_id) {
          this.AuthPartialRegService.partial_Reg(this.prosub_id, "", "").subscribe((r) => {
            this.applyPartialRegResponse(r);
          });
        }
      },
      (err) => {
        return err;
      }
    );
  }

  /**
   * Bind optmsg from partialregv2: prefer paymentHtml (currency DVs resolved).
   * Gift-card / raw opt_msg fall back through getDVFromString so tokens are not shown unresolved.
   */
  private applyPartialRegResponse(r: Data): boolean {
    if (!r) return false;

    this.loaded = true;
    this.progressBar = 100;
    // Copy when attaching vc — do not mutate the incoming nav-state / CF response object
    const response = this.vc ? { ...r, vc: this.vc } : r;
    this.versionPaymentPageData = response;
    this.additionalAwardId = response?.giftCardContent?.additional_award_id || "";

    const giftOptMsg = this.gc ? response?.giftCardContent?.opt_msg : undefined;
    const rawVersionOptMsg =
      response?.prosubDetail?.content?.[this.selectedLanguage]?.opt_msg ||
      response?.prosubDetail?.opt_msg;

    if (giftOptMsg) {
      this.resolveAndBindOptMsg(giftOptMsg);
      return true;
    }

    if (response.paymentHtml) {
      this.paymentPageData = response.paymentHtml;
      this.versionPaymentOptMsg = response.paymentHtml;
      this.changeDetectorRef.detectChanges();
      return true;
    }

    if (rawVersionOptMsg) {
      this.resolveAndBindOptMsg(rawVersionOptMsg);
    }

    return true;
  }

  private resolveAndBindOptMsg(rawHtml: Data): void {
    this.authService
      .getDVFromString(rawHtml)
      .then((resolved: Data) => {
        this.paymentPageData = resolved;
        this.versionPaymentOptMsg = resolved;
        this.changeDetectorRef.detectChanges();
      })
      .catch(() => {
        this.paymentPageData = rawHtml;
        this.versionPaymentOptMsg = rawHtml;
        this.changeDetectorRef.detectChanges();
      });
  }

  /**
   * The function `getCaseInsensitiveParamsValue` retrieves and stores case-insensitive parameter values
   * in localStorage.
   * @param {Params} params - The `getCaseInsensitiveParamsValue` function takes in a `Params` object as
   * a parameter. It then retrieves values from this object based on specific keys in a case-insensitive
   * manner. The keys it looks for are "tp1", "tp2", "tp3", and "t_id
   * @returns The `getCaseInsensitiveParamsValue` function returns an array of strings or null values.
   * This function iterates over predefined keys (tp1, tp2, tp3, t_id), attempting to find corresponding
   * values in the params object, regardless of the case of the keys. If a value is found, it is stored
   * in localStorage with the key in uppercase. If a value is not found in params, it tries to retrieve
   * it from localStorage. Finally, it returns an array containing the retrieved values or an error
   * object if an exception occurs.
   */
  private getCaseInsensitiveParamsValue(params: Params): (string | null)[] {
    try {
      const paramKeys = Object.keys(params);
      const tpValues = ["tp1", "tp2", "tp3", "t_id"];
      return tpValues.map((val) => {
        const value = params[paramKeys?.find((l) => l?.toLowerCase() == val)] ?? null;
        if (value) {
          this.safeLocalStorage.setItem(val.toUpperCase(), value);
          return value;
        }
        return this.safeLocalStorage.getItem(val.toUpperCase()) ?? value;
      });
    } catch (error) {
      return error;
    }
  }

  private voucherRedeemFormValidate() {
    this.voucherRedeemForm = this.fb.group({
      voucherCode: ["", Validators.required],
    });
  }

  async callInt2(voucherResponse) {
    this.paymentService.getOptionalPage("").then(async (resp) => {
      const post_name = resp;
      if (post_name === "free-reg-complete-profile") {
        try {
          this.authService.userDetails$.pipe(take(1)).subscribe(
            (user: any) => {
              if (user?.minimal_required == true) {
                this.safeLocalStorage.setItem("4dpage", "free-reg-step-4d");
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4d";
                this.paymentService.freeRegJourneySuccessURL = "voucherRedeemed";
                //this.router.navigateByUrl("successful-payment");
                this.router.navigateByUrl(this.paymentService.freeRegJourneySuccessURL);
                this.voucherService.voucher$.next(voucherResponse);
              } else {
                this.userProduct$.next(this.GTMservice.userProduct$.value);
                this.safeLocalStorage.setItem("4dpage", "free-reg-step-4d");
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4d";
                this.paymentService.freeRegJourneySuccessURL = post_name;
                //this.router.navigateByUrl("successful-payment");
                // this.router.navigateByUrl(`${post_name}`);
                this.router.navigateByUrl(
                  `${post_name +
                  "?prosub_id=" +
                  this.Prosub_id +
                  "&" +
                  "TP1=" +
                  this.TP1 +
                  "&" +
                  "TP2=" +
                  this.Tp2 +
                  "&" +
                  "TP3=" +
                  this.TP3 +
                  "&" +
                  "T_ID=" +
                  this.T_ID +
                  "&" +
                  "call_from=" +
                  this.callFromPromotion
                  }`
                );
                this.voucherService.voucher$.next(voucherResponse);
              }
            },
            (err) => {
              // this.snackService.openSnackBar("Something went wrong (user)", "", "custom-class-fail", "Error");
              /* const msg = this.translatedToastMsg?.["1013"]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : "Something went wrong (user)", "Error", ""); */
              this.authService.getConstantsMsg("1013").then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong (user)",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
            }
          );
        } catch (error) {
          //this.snackService.openSnackBar("Something went wrong", "", "custom-class-fail", "Error");
          /* const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "Something went wrong", "Error", ""); */
          this.authService.getConstantsMsg("1014").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
        }
      } else {
        this.safeLocalStorage.setItem("4cpage", "free-reg-step-4c");
        this.router.navigateByUrl(
          `${post_name +
          "&" +
          "TP1=" +
          this.TP1 +
          "&" +
          "TP2=" +
          this.Tp2 +
          "&" +
          "TP3=" +
          this.TP3 +
          "&" +
          "T_ID=" +
          this.T_ID +
          "&" +
          "call_from=" +
          this.callFromPromotion
          }`
        );
        this.voucherService.voucher$.next(voucherResponse);
      }
    });
  }

  issueAdditionalAwardId() {
    this.authService
      ?.getV2CloudFunction(
        "apisyncv2",
        this.RequestProfileService?.issueReferralGiftCard(this.additionalAwardId, this.reason)
      )
      .subscribe();
  }

  redeemVoucher(voucherCode: any, claimFromList, voucherObj?) {
    console.group("redeemVoucher called");
    console.log("Initial parameters:", { voucherCode, claimFromList, voucherObj });

    voucherCode = voucherCode ? voucherCode : this.vc;
    console.log("Resolved voucherCode:", voucherCode);

    if (!window.navigator.onLine) {
      console.warn("User is offline. Exiting redeemVoucher.");
      console.groupEnd();
      return;
    }

    console.log("Triggering GTM click event...");
    this.GTMservice.fourxCtaClicked();

    console.log("Resetting isVoucherIsInvalid$ flag");
    this.isVoucherIsInvalid$.next(false);

    this.claimFromList = claimFromList;
    if (this.claimFromList && voucherObj) {
      voucherObj.isClaiming = true;
      console.log("Marked voucher as claiming:", voucherObj);
    }

    this.claimSuccess = false;
    console.log("callFromPromotion:", this.callFromPromotion);
    console.log("additionalAwardId:", this.additionalAwardId);

    console.log("Calling voucherService.redeemVoucher API...");
    this.voucherService
      .redeemVoucher(voucherCode, "/api_post_request/4d_validate_voucher", this.callFromPromotion, this.additionalAwardId)
      .subscribe(
        async (voucherResponse: VoucherClaimResult) => {
          console.group("Voucher response received");
          console.log("Raw voucherResponse:", voucherResponse);

          // Add null/undefined safety check for voucherResponse
          if (!voucherResponse) {
            console.error("voucherResponse is null or undefined");
            this.proceed = true;
            if (this.claimFromList && voucherObj) {
              voucherObj.isClaiming = false;
            }
            
            this.authService.getConstantsMsg('1026').then((translatedMsg) => {
              const defaultMsg = {
                message: { line_1: "Something went wrong! Please try again.", line_2: "" },
                style: { icon: "tick circle error.svg", type: "Error" },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            });
            
            console.groupEnd();
            return;
          }

          this.progressBar = 100;
          console.log("Progress bar set to 100");

          this.sub?.unsubscribe();
          console.log("Unsubscribed from sub if existed");

          this.proceed = false;
          console.log("Proceed flag set to false");

          if (this.claimFromList && voucherObj) {
            voucherObj.isClaiming = false;
            console.log("Unset voucherObj.isClaiming:", voucherObj);
          }

          // Handle rejected voucher
          if (voucherResponse?.status === "rejected") {
            console.warn("Voucher rejected with error code:", voucherResponse.error_code);

            this.authService.getConstantsMsg(voucherResponse?.error_code).then((translatedMsg) => {
              console.log("Translated rejection message received:", translatedMsg);

              const defaultMsg = {
                message: { line_1: "Something went wrong!", line_2: "" },
                style: { icon: "tick circle error.svg", type: "Error" },
              };
              console.log("Showing default error toast:", defaultMsg);
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            });

            this.proceed = true;
            this.claimFromList = false;
            console.groupEnd();
            return false;
          }

          // Handle successful voucher
          if (voucherResponse.status?.toLowerCase() === "success") {
            console.log("Voucher redeemed successfully");

            this.voucherService.voucher$.next(voucherResponse);
            console.log("Updated voucher$ observable");

            this.voucherService.voucherRedeemed(voucherObj?.id);
            console.log("Called voucherRedeemed with ID:", voucherObj?.id);

            this.claimSuccess = true;
            this.isVoucherIsInvalid$.next(false);

            if (claimFromList) {
              console.log("Fetching translated 'voucher claimed' message...");

              const currentLang = this.translate.currentLang;
              const filter = ["cloud_function_messages", "STATICERRORMESSAGES", "VOUCHER CLAIMED"];
              console.log("Current language:", currentLang, "Filter path:", filter);

              this.authService
                .getV2CloudFunction("updatefirestoredoc", { path_id: "G2hzy28FznIF29mIsjoR", filter, method: "read" })
                .subscribe({
                  next: (res: any) => {
                    console.log("Cloud function response:", res);

                    const MsgsDetails = res?.data;
                    let nodeValue = MsgsDetails;
                    filter.forEach((key) => (nodeValue = nodeValue?.[key]));
                    const translatedMessage = nodeValue?.[currentLang];
                    console.log("Translated message after traversing filter:", translatedMessage);

                    const translatedMsg = {
                      message: { line_1: translatedMessage, line_2: "" },
                      style: { duration: 2000, icon: "tick circle success.png", type: "Success" },
                    };
                    const defaultMsg = {
                      message: { line_1: "voucher claimed successfully", line_2: "" },
                      style: { type: "Success", icon: "tick circle success.png" },
                    };

                    console.log("Showing toast message:", { translatedMsg, defaultMsg });
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                  },
                  error: (err) => console.error("Error fetching voucher claimed message:", err),
                });
            }

            // gift_status handling
            if (voucherResponse.gift_status == 0) {
              console.log("Processing gift_status 0 branch");

              this.progressBar = 100;
              this.spinnerAnimation = true;

              const path_id = "ERzajuwYcQgv2qQ1tA9q";
              const dv = { docId: voucherResponse.paid_prosub_id };
              const method = "read";

              console.log("Fetching Prosub details from cloud function", { path_id, dv, method });

              // Fix RxJS anti-pattern: Use switchMap instead of map + subscribe
              this.authService
                .getV2CloudFunction("updatefirestoredoc", { path_id, dv, method })
                .pipe(
                  switchMap((res: any) => {
                    console.log("Prosub details response:", res);

                    this.safeLocalStorage.setItem("savedCards", JSON.stringify(res || null));
                    console.log("Saved Prosub details to localStorage");

                    // Return the inner observable instead of subscribing to it
                    return this.AuthPartialRegService.partial_Reg(voucherResponse.paid_prosub_id, "", "");
                  })
                )
                .subscribe({
                  next: (res) => {
                    console.log("Partial registration completed, navigating to step 4c", res);

                    this.router.navigate(["/free-reg-step4c"], {
                      queryParams: {
                        prosub_id: voucherResponse?.paid_prosub_id,
                        TP1: this.TP1 || "null",
                        TP2: this.Tp2 || "null",
                        TP3: this.TP3 || "null",
                        T_ID: this.T_ID || "",
                        call_from: this.callFromPromotion,
                      },
                      state: res,
                    });
                  },
                  error: (error) => {
                    console.error("Error in gift_status flow:", error);
                    this.spinnerAnimation = false;
                    this.proceed = true;
                    
                    this.authService.getConstantsMsg('1026').then((translatedMsg) => {
                      const defaultMsg = {
                        message: { line_1: "Something went wrong! Please try again.", line_2: "" },
                        style: { icon: "tick circle error.svg", type: "Error" },
                      };
                      this.authService.showToastMessage(translatedMsg, defaultMsg);
                    });
                  }
                });
            } else {
              console.log("Calling callInt2 for voucherResponse:", voucherResponse);
              this.callInt2(voucherResponse);
            }
          } else {
            console.warn("Voucher claim unsuccessful", "Status:", voucherResponse.status, "Message:", voucherResponse.message);

            this.proceed = true;
            if (voucherObj) {
              this.voucherService.voucherRedeemed(voucherObj?.id);
              console.log("Called voucherRedeemed on unsuccessful claim:", voucherObj?.id);
            }

            if (voucherResponse.message?.toLowerCase().includes("no longer") && voucherObj) {
              console.log("Hiding invalid voucher:", voucherObj?.id);
              this.voucherService.hideInvalidVoucher(voucherObj?.id);
            }

            if (claimFromList) {
              console.log("Showing error toast for claimFromList:", voucherResponse.message);

              const translatedMsg = {
                message: { line_1: voucherResponse.message, line_2: "" },
                style: { duration: 2000, icon: "tick circle error.svg", type: "Error" },
              };
              const defaultMsg = {
                message: { line_1: "Something went wrong!", line_2: "" },
                style: { type: "Error", icon: "tick circle error.svg" },
              };

              this.authService.showToastMessage(translatedMsg, defaultMsg);
            } else {
              console.log("Setting isVoucherIsInvalid$ with message:", voucherResponse.message);
              this.isVoucherIsInvalid$.next(voucherResponse.message);
            }
          }

          this.claimFromList = false;
          console.groupEnd();
        },
        (error) => {
          console.error("Error during voucher redemption API call:", error);
          if (this.claimFromList && voucherObj) {
            voucherObj.isClaiming = false;
            console.log("Unset voucherObj.isClaiming due to error");
          }
          this.sub?.unsubscribe();
          this.spinnerAnimation = false;
          this.claimFromList = false;
        }
      );
  }



  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(60);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
      },
      (err) => {
        return err;
      }
    );
  }

  getButtonStatus(voucherCode: string) {
    this.isVoucherIsInvalid$.next("hello");
    this.isButtonDisabled = voucherCode === "";

    if (voucherCode === "") {
      this.isVoucherIsInvalid$.next("Voucher code is empty");
    } else {
      this.isVoucherIsInvalid$.next(false);
    }
  }

  skipToCompleteProfilePage() {
    this.router.navigateByUrl("/mainTabs/tabs/home");
  }

  private async onVoucherSuccessClaim(dialogData: any) {
    this.voucherService.voucher$.next(dialogData);
    this.router.navigateByUrl("/voucherRedeemed");
  }
}
